/* file description */

import React from 'react';
import { approvalRequest } from './request';
import zhCN from 'antd/es/locale/zh_CN';
import * as antd from 'antd';
import moment from 'moment';
import { Api, getDingEnvPlatform } from '@/utils';
import { Api as pureApi } from '@cui/req';


const { Modal, message } = antd;
const { confirm } = Modal;
export const loadFreeJs = (action, context, text) => {
  try {
    // eslint-disable-next-line no-new-func
    const pdfLib = require('pdf-lib');
    const fontkit = require('@pdf-lib/fontkit');
    if (!window.PDFLib || !window.fontkit) {
      loadFreeJs(action, context, text);
      return;
    }
    const loadCodeFetch = new Function('sp', 'ctx', text);
    const sp = { ...action, approvalRequest, React, pureApi, Api, getDingEnvPlatform, antd, message, confirm, moment, zhCN, pdfLib, fontkit };
    loadCodeFetch(sp, context);
  } catch (e) {
    console.error('=========解析自定义字符串失败==========');
    console.error(e);
  }
};
